/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ComponentInterface from '../../../core/component-interface';
import { addDep } from '../../dependency-manager';
import column3dManagerAnimation from '../../animation-rules/column3d-manager-animation';

addDep({
  name: 'column3dManagerAnimation',
  type: 'animationRule',
  extension: column3dManagerAnimation
});
/**
 * ColumnMultiSeriesgroup basically manages all the position of multiseries columns side by side.
 * suppose multiseries column chart contains 2 dataset now what will be the column width and
 * position to accomodate all the columns. This manager conveys the column width and position
 * for every column plots to its children
 */
class Column3dGroup extends ComponentInterface {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  /**
   * constructor function this class
   */
  constructor () {
    super();
    this.setState('visible', true);
  }

  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'group';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'column3d';
  }
  /**
   * function to calculate maximum canvas padding is required by the children of this manager
   * @return {Object} contains dimension required
   */
  getCanvasPadding () {
    var manager = this,
      dim,
      key,
      returnDimension = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };

    manager._mapChildren((child) => {
      dim = (child.getCanvasPadding && child.getCanvasPadding()) || {};
      for (key in dim) {
        if (dim.hasOwnProperty(key)) {
          returnDimension[key] = Math.max(dim[key], returnDimension[key]);
        }
      }
    });
    return returnDimension;
  }
  /**
   * Create child containers
   */
  createContainer () {
    let manager = this,
      animationManager = manager.getFromEnv('animationManager'),
      key,
      parent = manager.getLinkedParent(),
      pContainer,
      parentChildContainers = parent.getChildContainer();

    for (key in parentChildContainers) {
      pContainer = parentChildContainers[key];

      !manager.getChildContainer(key) && manager.addChildContainer(
        key,
        animationManager.setAnimation({
          el: 'group',
          attr: {
            name: 'manager' + key
          },
          container: pContainer,
          component: manager,
          label: 'group'
        })
      );
    }
  }
  /**
   * Draws container for 3d plots
   */
  draw3DContainer () {
    var manager = this,
      animationManager = manager.getFromEnv('animationManager'),
      container = manager.getChildContainer('plotGroup3d'),
      xAxis = manager.getFromEnv('xAxis'),
      ii = xAxis.getTicksLen(),
      i,
      plotNegativeGroup = container && container.negative,
      plotPositiveGroup = container && container.positive,
      parentContainer = this.getLinkedParent().getChildContainer().columnVcanvasGroup;

    // Create plotGroup3d group
    !manager.getChildContainer('plotGroup3d') && manager.addChildContainer(
      'plotGroup3d',
      animationManager.setAnimation({
        el: 'group',
        attr: {
          name: '3d-plots'
        },
        container: parentContainer,
        component: manager,
        label: 'group'
      })
    );
    container = manager.getChildContainer('plotGroup3d');
    manager.addToEnv('plotGroup3d', container);

    // Create plotNegativeGroup
    plotNegativeGroup = container.negative = animationManager.setAnimation({
      el: plotNegativeGroup || 'group',
      attr: {
        name: 'negative-values'
      },
      container: container,
      component: manager,
      label: 'group'
    });

    // Create plotPositivegroup
    plotPositiveGroup = container.positive = animationManager.setAnimation({
      el: plotPositiveGroup || 'group',
      attr: {
        name: 'positive-values'
      },
      container: container,
      component: manager,
      label: 'group'
    });

    // Create zeroPlane group
    container.zeroPlane = animationManager.setAnimation({
      el: container.zeroPlane || 'group',
      attr: {
        name: 'zero-plane'
      },
      container: container,
      component: manager,
      label: 'group'
    }).insertBefore(container.positive);
    // Create Negative group array for data plots having Negative value, if not present.
    if (!(container.negativeGroupArray =
                container.negativeGroupArray = plotNegativeGroup.data('categoryplots'))) {
      plotNegativeGroup.data('categoryplots', new Array(ii));
      container.negativeGroupArray = plotNegativeGroup.data('categoryplots');
    }

    // Create Positive group array for data plots having Positive value, if not present.
    if (!(container.positiveGroupAarray =
                container.positiveGroupAarray = plotPositiveGroup.data('categoryplots'))) {
      plotPositiveGroup.data('categoryplots', new Array(ii));
      container.positiveGroupAarray = plotPositiveGroup.data('categoryplots');
    }

    for (i = 0; i < ii; i++) {
      /*
      * Create seperate group for each data plot having Negative value, if not present.
      * Store the group in Negative group array
      */
      container.negativeGroupArray[i] = animationManager.setAnimation({
        el: container.negativeGroupArray[i] || 'group',
        attr: {
          name: 'negative-group-' + i
        },
        container: plotNegativeGroup,
        component: manager,
        label: 'group'
      });

      /*
      * Create seperate group for each data plot having Positive value, if not present.
      * Store the group in Positive group array
      */
      container.positiveGroupAarray[i] = animationManager.setAnimation({
        el: container.positiveGroupAarray[i] || 'group',
        attr: {
          name: 'positive-group-' + i
        },
        container: plotPositiveGroup,
        component: manager,
        label: 'group'
      });
    }
  }
  /**
   * Draws zero plane
   */
  drawZeroPlane () {
    var manager = this,
      chart = manager.getFromEnv('chart'),
      animationManager = chart.getFromEnv('animationManager'),
      isBar = chart.isBar,
      chartConfig = chart.config,
      use3DLighting = chartConfig.use3dlighting,
      container = manager.getChildContainer('plotGroup3d'),
      yAxis = manager.getFromEnv('yAxis'),
      yAxisMaxmin = yAxis.getLimit(),
      yMax = yAxisMaxmin.max,
      yMin = yAxisMaxmin.min,
      zeroPlane = manager.getGraphicalElement('zeroplane'),
      zeroplaneAttr = {},
      xDepth = chartConfig.xDepth,
      yDepth = chartConfig.yDepth,
      yBasePos = yAxis.getPixel(yAxis.getAxisBase()),
      MINWIDTH = 1,
      data,
      attr,
      zeroPlaneGroup;

    if (yMin < 0 && yMax >= 0) {
      !manager.graphics && (manager.graphics = {});
      zeroPlaneGroup = container.zeroPlane;
      zeroplaneAttr.fill = chartConfig.zeroPlaneColor;
      zeroplaneAttr.noGradient = !use3DLighting;
      zeroplaneAttr.stroke = chartConfig.zeroPlaneBorderColor || 'none';
      zeroplaneAttr['stroke-width'] = chartConfig.zeroPlaneShowBorder ? 1 : 0;
      zeroplaneAttr.x = isBar ? yBasePos - xDepth : chartConfig.canvasLeft - xDepth;
      zeroplaneAttr.y = isBar ? chartConfig.canvasTop + yDepth : yBasePos + yDepth;
      zeroplaneAttr.width = isBar ? MINWIDTH : chartConfig.canvasWidth;
      zeroplaneAttr.height = isBar ? chartConfig.canvasHeight : MINWIDTH;
      zeroplaneAttr.xDepth = xDepth;
      zeroplaneAttr.yDepth = yDepth;

      // If zeroPlane is present, show it.
      if (zeroPlane) {
        zeroPlane.show();
        zeroPlane._.cubetop.show();
        zeroPlane._.cubeside.show();
      }
      data = {
        el: zeroPlane || 'cubepath',
        attr: zeroplaneAttr,
        container: zeroPlaneGroup,
        component: manager,
        label: 'zeroPlane'
      };
    } else {
      if (zeroPlane) {
        if (isBar) {
          attr = {
            x: yBasePos - yDepth
          };
        } else {
          attr = {
            y: yBasePos + yDepth
          };
        }
        data = {
          el: zeroPlane,
          attr: attr,
          component: manager,
          doNotRemove: true,
          callback: function () {
            zeroPlane.hide();
            zeroPlane._.cubetop.hide();
            zeroPlane._.cubeside.hide();
          },
          container: container,
          label: 'zeroPlane'
        };
      }
    }

    data && manager.addGraphicalElement(
      'zeroplane',
      animationManager.setAnimation(data)
    );
  }
  /**
   * function call sync draw of its children
   */
  draw () {
    this.createContainer();
    this.draw3DContainer();
    this.drawZeroPlane();
  }
  /**
   * function to accomodate the changes of its child and notify its parent for further action if its needed
   * @param  {Object} updateInfo is an object with the informations about the changes in its child
   */
  childChanged (updateInfo = {}) {
    let manager = this,
      config = manager.config,
      parent = manager.getLinkedParent(),
      range,
      count = 0,
      prevVisiblity = manager.getState('visible'),
      changeInfo = {},
      informParent;
    // get the number of visible children
    manager._mapChildren((child) => {
      if (child.getState('visible')) {
        count++;
      }
    });
    // set the manager visiblity according to number of children visible
    manager.setState('visible', !!count);
    // if the visiblity state changed then parent inform flag set to true
    (prevVisiblity !== !!count) && (informParent = true);
    // if the managers data limit get changed then also inform the parent
    if (updateInfo.dataLimitChanged !== false) {
      range = manager.getDataLimits();
      if (range.min !== config.range.min || range.max !== config.range.max) {
        config.range.min = range.min;
        config.range.max = range.max;
        changeInfo.dataLimitChanged = true;
        informParent = true;
      }
    }
    // if the axis value got changed then inform parent
    // right now we do not change value padding on any type of update
    // if (updateInfo.paddingChanged !== false) {
    //   padding = manager.getAxisValuePadding();
    //   if (padding.left !== config.padding.left || padding.right !== config.padding.right) {
    //     config.padding.left = padding.left;
    //     config.padding.right = padding.right;
    //     changeInfo.paddingChanged = true;
    //     informParent = true;
    //   }
    // }
    if (informParent) {
      parent.childChanged && parent.childChanged(changeInfo);
    } else {
      manager.asyncDraw();
    }
  }
  /**
   * function to get value for axis padding from is children
   * @return {Object} with left and right member
   */
  getAxisValuePadding () {
    let paddingObj = {},
      axisPaddingLeft = -Infinity,
      axisPaddingRight = -Infinity;
    this._mapChildren((child) => {
      if (child.getState('removed')) {
        return;
      }
      paddingObj = (child.getAxisValuePadding && child.getAxisValuePadding()) || {};
      axisPaddingLeft = Math.max(axisPaddingLeft, paddingObj.left || -Infinity);
      axisPaddingRight = Math.max(axisPaddingRight, paddingObj.right || -Infinity);
    });

    if (axisPaddingLeft === -Infinity) {
      axisPaddingLeft = 0;
    }
    if (axisPaddingRight === -Infinity) {
      axisPaddingRight = 0;
    }
    if (!this.config.padding) {
      this.config.padding = {};
      this.config.padding.left = axisPaddingLeft;
      this.config.padding.right = axisPaddingRight;
    }
    return {
      left: axisPaddingLeft,
      right: axisPaddingRight
    };
  }
  /**
   * function to get data limits from its child datasets
   * return minimun and maximum value among the datasets limit
   * @param {boolean} allVisible  whether consider all the datasets are visible or not
   * @return {Object}             [min, max]
   */
  getDataLimits (allVisible) {
    let manager = this,
      min = +Infinity,
      max = -Infinity,
      maxminObj,
      numOfColumns = 0,
      getMaxMin = function (_maxminObj) {
        max = Math.max(max, _maxminObj.max);
        min = Math.min(min, _maxminObj.min);
      };

    manager._mapChildren((child) => {
      if (child.getState('removed')) {
        return;
      }
      if (child.getState('visible') === false) {
        if (allVisible) {
          maxminObj = child.getDataLimits(allVisible);
          getMaxMin(maxminObj);
        }
        return;
      }
      numOfColumns++;
      maxminObj = child.getDataLimits(allVisible);
      getMaxMin(maxminObj);
    });
    if (!numOfColumns) {
      manager.setState('visible', false);
    } else {
      manager.setState('visible', true);
    }
    if (!this.config.range) {
      this.config.range = {};
      this.config.range.min = this.config.dataMin;
      this.config.range.max = this.config.dataMax;
    }
    return { max, min };
  }
  /**
   * it return the status of dataset visiblity
   * @return {boolean} returns the visiblity status of dataset
   */
  isVisible () {
    return !this.isNotVisible;
  }
}
export default Column3dGroup;
